import { BaseInputFieldFilter, FilterLabelProps } from "@duosoftbg/nacid-components";
import React from "react";

const TextFilter = ({ label = "l.searchFilter.text", ...others }: FilterLabelProps) => {
  return <BaseInputFieldFilter label={label} fieldName={"text"} {...others} />;
};

export default TextFilter;
